import { useMemo } from "react";

export const useId = (id: string | Array<string | number>) => {
  return useMemo(() => {
    if (Array.isArray(id)) {
      const jointId = id
        .map((i) => i.toString().trim().toLowerCase().replace("#", ""))
        .join("-");

      return [jointId, `#${jointId}`];
    }
    return [id, `#${id}`];
  }, [id]);
};
